import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtLicenseList } from 'containers';
import { LicenseMenu, MyPageTitle, MyPageTemplate } from 'components';

class CtLicense extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <MyPageTemplate>
        <MyPageTitle
          small
          title={defineMessages(formatMessage({ id: 'CtLicense_1', defaultMessage: '라이센스' }))}>
          <LicenseMenu />
        </MyPageTitle>
        <CtLicenseList />
      </MyPageTemplate>
    );
  }
}

CtLicense.propTypes = {};
CtLicense.defaultProps = {};

export default injectIntl(CtLicense);



// WEBPACK FOOTER //
// ./src/script/containers/license/CtLicense.js